//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'pch_provider_rut',
        format: 'rut',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_alias_name',
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle proveedor',
            },
        },
    },
    {
        text: 'sucursal',
        value: 'pch_provider_branch_offices_address',
    },
    {
        text: 'responsable',
        value: 'g_supervisor_user_full_name',
    },
    {
        text: 'bodega',
        value: 'wh_warehouse_name',
    },
    {
        text: 'prioridad',
        value: 'wh_orderer_priority_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    media: 'secondary lighten-3',
                    baja: 'success lighten-3',
                    alta: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
    },
    {
        text: 'procesada',
        value: 'was_processed',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'fecha de creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]
